import { render, staticRenderFns } from "./ny_zhishi.vue?vue&type=template&id=e4560b60&scoped=true&"
import script from "./ny_zhishi.vue?vue&type=script&lang=js&"
export * from "./ny_zhishi.vue?vue&type=script&lang=js&"
import style0 from "./ny_zhishi.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ny_zhishi.vue?vue&type=style&index=1&id=e4560b60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4560b60",
  null
  
)

export default component.exports